// Dedicated Training page. Everything training-related in one place, split
// out from the Assessment page (which is a lower-frequency check-in).
//
// Layout (top → bottom):
//   1. This-week summary + streak
//   2. Primary trainer contact card
//   3. Training sessions (formal / informal / rehab + file attachments)
//   4. Verbal cues (the vocabulary you use with this dog)
//   5. Skill progress tracker
import { useDogs } from "@/context/DogsContext";
import EmptyDogState from "@/components/app/EmptyDogState";
import { SectionTitle } from "@/components/app/Bits";
import TrainingWeekSummary from "@/components/app/TrainingWeekSummary";
import TrainersCard from "@/components/app/TrainersCard";
import ClassesSection from "@/components/app/ClassesSection";
import TrainingNotesSection from "@/components/app/TrainingNotesSection";
import VerbalCuesSection from "@/components/app/VerbalCuesSection";
import SkillsSection from "@/components/app/SkillsSection";

export default function TrainingPage() {
  const { activeDog } = useDogs();
  if (!activeDog) return <EmptyDogState />;
  return (
    <div className="space-y-8" data-testid="training-page">
      <SectionTitle overline="Every session counts" title="Training" />
      <p className="text-sm text-muted-foreground max-w-2xl -mt-4">
        Track sessions, cues, and progress for <strong>{activeDog.name}</strong> in one place.
        Log the day-to-day here; save the deep, honest look for the Assessment page.
      </p>

      <TrainingWeekSummary dogId={activeDog.id} />
      <TrainersCard dogId={activeDog.id} />
      <ClassesSection dogId={activeDog.id} />
      <TrainingNotesSection dogId={activeDog.id} dogName={activeDog.name} />
      <VerbalCuesSection dogId={activeDog.id} dogName={activeDog.name} />
      <SkillsSection dogId={activeDog.id} />
    </div>
  );
}
